export default __webpack_public_path__ + "static/snowflakependantback-828fb4c38518e0efde251c5ab6d3f23c.png";